// APP版本管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/contentManager/getAppVersionList", data);

// 新增
export const add = (data) => http.post("/web/contentManager/addAppVersion", data);

// 删除
export const del = (data) => http.post("/web/contentManager/deleteAppVersion", data);

// 详情
export const detail = (data) => http.post("/web/contentManager/getAppVersionDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/contentManager/updateAppVersion", data);